import { render, staticRenderFns } from "./ProfileImage.vue?vue&type=template&id=856f2f62&scoped=true&"
import script from "./ProfileImage.vue?vue&type=script&lang=js&"
export * from "./ProfileImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856f2f62",
  null
  
)

export default component.exports